import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const TagStyle = {
  display: "inline-block",
  padding: "4px 12px",
  background: "rgba(41, 100, 225, 0.1)",
  borderRadius: "40px",
  color: "#14a077",
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "12px",
  marginRight: "8px"
};

function Category077() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/allastrologerssort")
      .then((response) => {
        const rows = Array.isArray(response.data) ? response.data : [];

        // Priority sorting: Permanent → Contractual → others
        const priority = (ctype) => {
          const t = String(ctype || "").trim().toLowerCase();
          if (t === "permanent") return 0;
          if (t === "contractual") return 1;
          return 2;
        };

        const sorted = rows.slice().sort((a, b) => {
          const pa = priority(a.Ctype);
          const pb = priority(b.Ctype);
          if (pa !== pb) return pa - pb;

          // secondary sort by name
          const nameA = String(a.Named || "").toLowerCase();
          const nameB = String(b.Named || "").toLowerCase();
          return nameA.localeCompare(nameB);
        });

        setData(sorted);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <section
      className="testimonials-category-section"
      style={{ paddingTop: "20px", paddingBottom: "20px" }}
    >
      <div className="tf-container">
        <div className="row">
          <div className="col-md-12">
            <div className="tf-title style-2" style={{ marginBottom: "20px" }}>
              <div className="group-title">
                <h1 style={{ marginBottom: "0px", fontSize: "30px" }}>
                  Find Your Guiding Star
                </h1>
                <p>
                  Explore our community of trusted and verified astrology
                  experts.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-10" style={{ margin: "auto" }}>
            <div className="row">
              {data.map((item) => {
                const ctype = String(item.Ctype || "").trim().toLowerCase();
                const isPermanent = ctype === "permanent";
                const isContractual = ctype === "contractual";

                return (
                  <div
                    key={item.Id || item.Named}
                    className="col-lg-4 col-md-4 col-12"
                  >
                    <Link
                      to={`/astroservices`}
                      className="text-decoration-none"
                    >
                      <div
                        className="group-category-job padding wow fadeInUp"
                        style={{ paddingBottom: "10px" }}
                      >
                        <div
                          style={{
                            width: "unset",
                            padding: "18px",
                            marginLeft: "20px",
                            marginBottom: "20px",
                            borderRadius: "8px",
                            backgroundColor: "#f5f5f5",
                            boxShadow: "0px 2px 2px rgba(28, 36, 51, 0.1)"
                          }}
                        >
                          <div
                            className="job-category-header"
                            style={{ marginBottom: "0px" }}
                          >
                            <img
                              src={item.Path1 || "default-image.jpg"}
                              alt={item.Named}
                              style={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "10px"
                              }}
                            />

                            {/* Trusted / Verified badges */}
                            <div style={{ marginTop: 0 }}>
                              {isPermanent && <p style={TagStyle}>Trusted</p>}
                              {(isPermanent || isContractual) && (
                                <p style={TagStyle}>Verified</p>
                              )}
                            </div>

                            <h1
                              style={{
                                marginTop: "8px",
                                fontWeight: 600,
                                fontSize: "18px",
                                color: "#111",
                                marginBottom: "12px"
                              }}
                            >
                              {item.Named}
                            </h1>

                            {/* Services */}
                            <p
                              style={{
                                marginBottom: "6px",
                                color: "#555",
                                fontSize: "14px"
                              }}
                            >
                              <strong>Service(s) Offered:</strong>{" "}
                              {item.Services && item.Services.trim()
                                ? item.Services
                                : "No services listed"}
                            </p>

                            {/* Languages */}
                            <p
                              style={{
                                marginBottom: "8px",
                                color: "#555",
                                fontSize: "14px"
                              }}
                            >
                              <strong>Language(s) Known:</strong>{" "}
                              {item.Languages && item.Languages.trim()
                                ? item.Languages
                                : "Not specified"}
                            </p>

                            <div>
                              <span
                                className="btn-category-job"
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  color: "#14a077",
                                  fontWeight: "bold"
                                }}
                              >
                                Choose a Service to Continue
                                <span
                                  className="icon-keyboard_arrow_right"
                                  style={{ marginLeft: 6 }}
                                ></span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Category077;